// Debug script to identify what's causing the padding issue
document.addEventListener("DOMContentLoaded", function() {
  if (document.body.classList.contains("template-index")) {
    // Function to log all styles affecting the navigation
    function logStyles(element, label) {
      if (!element) return;

      const styles = window.getComputedStyle(element);
    }

    // Log initial styles
    const headerMenu = document.querySelector(".header__inline-menu");
    if (headerMenu) {
      logStyles(headerMenu, "Initial header__inline-menu styles");

      // Force styles and log again
      headerMenu.style.setProperty("padding-left", "0", "important");
      headerMenu.style.setProperty("margin-left", "0", "important");

      logStyles(headerMenu, "After forcing styles");

      // Set up a MutationObserver to detect changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === "attributes" &&
              (mutation.attributeName === "style" || mutation.attributeName === "class")) {
            logStyles(headerMenu, "After detected change");

            // Force styles again
            headerMenu.style.setProperty("padding-left", "0", "important");
            headerMenu.style.setProperty("margin-left", "0", "important");
          }
        });
      });

      // Observe the element for changes
      observer.observe(headerMenu, {
        attributes: true,
        attributeFilter: ["style", "class"]
      });

      // Check every 500ms for 10 seconds
      let count = 0;
      const interval = setInterval(function() {
        count++;
        logStyles(headerMenu, `Check #${count}`);

        // Force styles again
        headerMenu.style.setProperty("padding-left", "0", "important");
        headerMenu.style.setProperty("margin-left", "0", "important");

        if (count >= 20) {
          clearInterval(interval);
        }
      }, 500);
    }
  }
});
